module.exports = __webpack_public_path__ + "img/商丘市-c.62a79b4f.png";